import { BannerTypes } from '../IGoogleTag';

export class PresentationBannerClusterInfo {
	public constructor(
		public readonly bannerIds: string[],
		public readonly cssClass: string,
		public readonly type: BannerTypes,
	) {}
}
